
import { useMediaQuery } from '@chakra-ui/react';

// Hook بسيط بيستخدم Chakra UI لمعرفة إذا كانت الشاشة صغيرة (موبايل)
 const useIsMobile = () => {
    // 768px هو الـ breakpoint بتاع 'md' في Chakra
    const [isMobile] = useMediaQuery("(max-width: 767px)");
    return isMobile
};

export default useIsMobile